type CancelableDebounce = (() => void) & { cancel: () => void };

export function debounce(
	func: Function,
	wait: number,
	immediate: boolean = false
): CancelableDebounce {
	let timeout: NodeJS.Timeout | null;
	function debounced() {
		// @ts-ignore
		const context = this,
			args = arguments;
		if (timeout) {
			clearTimeout(timeout);
		}
		if (immediate && !timeout) func.apply(context, args);
		timeout = setTimeout(function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		}, wait);
	}

	debounced.cancel = function () {
		if (timeout) {
			clearTimeout(timeout);
		}
	};
	return debounced as CancelableDebounce;
}
